import { render, staticRenderFns } from "./tempIntroduce.vue?vue&type=template&id=37fa1f29&scoped=true&"
import script from "./tempIntroduce.vue?vue&type=script&lang=js&"
export * from "./tempIntroduce.vue?vue&type=script&lang=js&"
import style0 from "./tempIntroduce.vue?vue&type=style&index=0&id=37fa1f29&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37fa1f29",
  null
  
)

export default component.exports